/* eslint-disable indent */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCompSalesData } from "src/api/bi";
import stringToNumber from "src/utils/stringToNumber";
import { BarChartsInitialState } from "../../interface";
import { filterByDepartment } from "../../utils";

export const fetchCompSalesData = createAsyncThunk(
  "dashboard/fetchCompSalesData",
  ({
    storeId,
    fromDate,
    toDate,
    _department,
    departmentId
  }: {
    storeId: string;
    fromDate: string;
    toDate: string;
    _department?: string;
    departmentId: string;
  }) => getCompSalesData({ storeId, fromDate, toDate })
);

const initialState: BarChartsInitialState = {
  data: [],
  status: "idle",
  error: "",
  currentPage: 1,
  totalPages: 10,
  recordsPerPage: 5
};

const compSalesSlice = createSlice({
  name: "compSales",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchCompSalesData.pending, (state) => {
        state.status = "pending";
      })
      .addCase(fetchCompSalesData.fulfilled, (state, action) => {
        const payload = action.payload;
        const { _department: department, departmentId } = action.meta.arg;
        state.status = "idle";

        if (!payload?.data?.length) {
          state.data = null;
          return;
        }

        const data = payload.data.map((item: any) => ({
          consAmount: stringToNumber(item.consAmount),
          currentYear: stringToNumber(item.currentYear),
          goal: stringToNumber(item.goal),
          department:
            item?.department === "Total" ? "All Dept" : item?.department?.name,
          id: item?.department?.id || ""
        }));

        state.data = filterByDepartment(data, department, departmentId);
      })
      .addCase(fetchCompSalesData.rejected, (state) => {
        state.status = "error";
        state.data = null;
      });
  }
});

export const selectData = ({
  compSales
}: {
  compSales: BarChartsInitialState;
}) => compSales.data;

export const selectStatus = ({
  compSales
}: {
  compSales: BarChartsInitialState;
}) => compSales.status;

export default compSalesSlice.reducer;
